<template>
  <v-col class="pa-0">
    <v-row class="container pa-0 ma-0" justify="center" align="center">
      <!-- phone -->
      <div v-if="pageStep === 1" class="button-container">
        <v-form @submit.prevent>
          <UiInput
              placeholder="+7 (---) --- -- --"
              clearable
              label="Ваш телефон"
              :mask="phoneOptions"
              v-model="phone"
              style="margin-bottom: 28px"
          />

          <!-- Проверка на длину грязного телефона, 18 символов -->
          <UiButton v-if="phone.length < 18">
            <v-icon icon="mdi-arrow-up" />
            Введите номер
          </UiButton>

          <div v-else>
            <UiButton @click="sendPhoneInfo" bgColor="blue"> Выслать код </UiButton>
            <p class="txt-cap1 color-gray" style="margin-top: 18px">
              Нажимая на кнопку код подтверждения будет отправлен вам в Telegram
            </p>
          </div>
        </v-form>
      </div>

      <!-- OTP-код -->
      <div v-if="pageStep === 2" class="button-container text-center">
        <p class="code-title text-left ma-0 pl-4">Введите код из Telegram:</p>
        <div
            style="
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        margin-top: 40px;
                        margin-bottom: 35px;
                    "
        >
          <v-otp-input
              ref="otpInput"
              input-classes="otp-input"
              separator=""
              :num-inputs="4"
              v-model:value="otpCode"
              :should-auto-focus="true"
              input-type="number"
              @on-complete="sendCode"
          />
        </div>
        <v-chip v-show="codeError" class="chip mt-4"> Неверный код </v-chip>
        <v-progress-circular
            v-if="isLoading"
            width="2"
            class="loading mx-auto text-center mt-4"
            color="active"
            indeterminate
        ></v-progress-circular>
        <v-col v-if="!isLoading" class="text-left mt-2">
          <p class="text-code ma-0">Не пришел код?</p>
          <a  href="javascript:void(0);" @click="sendPhoneInfo" class="text-code-href ma-0">Отправить снова</a>
        </v-col>
      </div>
    </v-row>
  </v-col>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import { postUserLoginCode, postUserConfirmCode } from '@/API/ways/user'
import UiButton from '@/components/ui-kit/UiButton.vue'
import UiInput from '@/components/ui-kit/UiInput.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const phone = ref('')
const phoneOptions = { mask: '+7 (###) ###-##-##' }
const otpCode = ref('')
const clearPhone = computed(() => {
  return phone.value.match(/\d/g).join('')
})
const codeError = ref(false)
const isLoading = ref(false)

const pageStep = ref(1)
onMounted(async () => {
  localStorage.clear();
})

async function sendPhoneInfo() {
  codeError.value = false
  if (phone.value != null)
    await postUserLoginCode(clearPhone.value).then((response) => {
      try {
        if (response.data.operationResult === 'OK') {
          pageStep.value = 2
        }
      } catch (e) {
        console.error('error text:', e)
      }
    })
}

async function sendCode() {
  if (clearPhone.value && otpCode.value != null) {
    isLoading.value = true
    await postUserConfirmCode(clearPhone.value, otpCode.value)
        .then((response) => {
          if (response.data.operationResult === 'OK') {
            localStorage.setItem('userToken', response.data.object.jwtToken);
            localStorage.setItem('userId', response.data.object.user.id);
            localStorage.setItem('role', response.data.object.user.role.code);
            console.log("set token");
            if (localStorage.getItem('role') === 'ROLE_ADMIN') {
              router.push('/admin/adminPage');
            } else {
              router.push('/admin/userPage');
            }
          }
        })
        .catch((e) => {
          otpCode.value = ""
          codeError.value = true
          console.error('error text:', e)
        })
        .finally(() => (isLoading.value = false))
  }
}

</script>

<style lang="scss">
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &__error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.chip {
  background: #ffebee !important;
  border: 1px solid rgba(255, 61, 0, 0.2) !important;
  color: #ff3d00 !important;
  font-size: 18px !important;
  border-radius: 100px !important;
  line-height: 22px !important;
  width: 100% !important;
  height: 54px !important;
  justify-content: center !important;
}
</style>

<style scoped>
.container {
  height: 80vh;
}
.button-container {
  width: 80%;
}
.input {
  border-radius: 12px;
}
.button {
  border-radius: 12px;
  border: 1px solid #263238 !important;
}
.your-phone-text {
  font-size: 13px;
  line-height: 14px;
  letter-spacing: 0.01em;
  color: #9e9e9e;
}
.your-phone-href {
  font-size: 13px;
  line-height: 14px;
  text-decoration: none;
  letter-spacing: 0.01em;
  color: #29b6f6;
}
.button-validate {
  background: linear-gradient(96.78deg, #13d5ff -0.02%, #12a1de 94.31%) !important;
  border: 1px solid #12b7ec !important;
  box-shadow: 0 22px 22px -17px #29b6f6 !important;
  border-radius: 12px !important;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
.button-validate-text {
  font-size: 13px;
  line-height: 14px;
  letter-spacing: 0.01em;
  color: #9e9e9e;
}
.code-title {
  font-size: 16px;
  line-height: 18px;
  color: #263238;
}
.otp {
  width: 205px;
  margin: auto;
}

.text-code {
  font-size: 13px;
  line-height: 14px;
  letter-spacing: 0.01em;
  color: #9e9e9e;
}
.text-code-href {
  font-size: 13px;
  line-height: 14px;
  text-decoration: none;
  letter-spacing: 0.01em;
  color: #29b6f6;
}
.loading {
  width: 38px !important;
  height: 38px !important;
}
</style>
